var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},[_c('div',{staticClass:"AppSide"},[_c('vue-components-markdown',{attrs:{"content":_vm.tocContent}})],1),_c('div',{staticClass:"AppMain"},[_c('vue-components-markdown',{attrs:{"content":_vm.content,"component-map":_vm.componentMap,"markdown-processor-props":{
        toc: true,
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }